export const isUsingAirtableRealtimeUpdates = (dataConnection: DataConnectionDto): boolean =>
    dataConnection.type === 'airtable' && dataConnection.version === 2
